module.exports = __webpack_public_path__ + "img/AmericanExpress.9b34ab27.png";